import { Component, OnInit } from '@angular/core';
import { RegisterClass } from '@memberjunction/global';
import { BaseResourceComponent } from '@memberjunction/ng-shared';
import { Metadata } from '@memberjunction/core';

@Component({
  standalone: false,
  selector: 'bc-profile-nav',
  template: `
    <div class="profile-dashboard">
      <div class="page-header">
        <h1 class="page-title">My Profile</h1>
        <p class="page-subtitle">Manage your personal information and organization memberships</p>
      </div>
      <div class="dashboard-columns">
        <div class="dashboard-column dashboard-column--primary">
          @if (!Editing) {
            <bc-user-profile-viewer
              [userEmail]="UserEmail"
              (editRequested)="Editing = true">
            </bc-user-profile-viewer>
          } @else {
            <bc-user-profile-editor
              [userEmail]="UserEmail"
              (saved)="Editing = false"
              (cancelled)="Editing = false">
            </bc-user-profile-editor>
          }
        </div>
        <div class="dashboard-column dashboard-column--secondary">
          <bc-organization-membership-list></bc-organization-membership-list>
        </div>
      </div>
    </div>
  `,
  styles: [`
    :host {
      display: block;
    }

    .profile-dashboard {
      max-width: 1200px;
      margin: 0 auto;
      padding: 32px 24px;
    }

    .page-header {
      margin-bottom: 32px;
    }

    .page-title {
      margin: 0 0 6px 0;
      font-size: 28px;
      font-weight: 700;
      color: var(--bc-text-primary, #212529);
      letter-spacing: -0.02em;
    }

    .page-subtitle {
      margin: 0;
      font-size: 15px;
      color: var(--bc-text-muted, #6c757d);
      line-height: 1.5;
    }

    .dashboard-columns {
      display: flex;
      gap: 28px;
      align-items: flex-start;
    }

    .dashboard-column {
      min-width: 0;
    }

    .dashboard-column--primary {
      flex: 1.15;
    }

    .dashboard-column--secondary {
      flex: 1;
    }

    @media (max-width: 900px) {
      .dashboard-columns {
        flex-direction: column;
      }

      .dashboard-column--primary,
      .dashboard-column--secondary {
        flex: 1;
        width: 100%;
      }
    }

    @media (max-width: 768px) {
      .profile-dashboard {
        padding: 20px 16px;
      }

      .page-header {
        margin-bottom: 24px;
      }

      .page-title {
        font-size: 24px;
      }
    }
  `]
})
@RegisterClass(BaseResourceComponent, 'ProfileResource')
export class BCProfileNavComponent extends BaseResourceComponent implements OnInit {
  Editing = false;
  UserEmail = '';

  constructor() {
    super();
  }

  async GetResourceDisplayName(): Promise<string> {
    return 'Profile';
  }

  async GetResourceIconClass(): Promise<string> {
    return 'fa-solid fa-user';
  }

  override ngOnInit() {
    const md = new Metadata();
    this.UserEmail = md.CurrentUser?.Email || '';
    this.NotifyLoadComplete();
  }
}
